import { Typography } from '@navi/web-ui/lib/primitives';
import BotIcon from '@cp/src/assets/icons/BotIcon';

const PreAuditBanner = () => {
  return (
    <div className="bg-[var(--bg-primary-warm)]">
      <div className="flex flex-row gap-1 items-center py-2 px-3 bg-[var(--bg-blue)] rounded-t-lg shadow-md">
        <Typography variant="p5" color="var(--grayscale-2)">
          Pre-Audit done by AI
        </Typography>
        <BotIcon />
      </div>
    </div>
  );
};

export default PreAuditBanner;
